import { PatientDocument } from 'common/enum/patient-document'
import { SurgicalOrderModel } from 'domain/entities/surgical-order-model'
import { fromBuffer } from 'file-type/core'

export const buildAuthorizationGuideFile = async (
  data: Blob,
  fallbackContentType: string,
  baseName?: string
): Promise<File> => {
  const buffer = await data.arrayBuffer()
  const detected = await fromBuffer(buffer)
  const type = detected?.mime ?? fallbackContentType
  const name =
    baseName && detected?.ext ? `${baseName}.${detected.ext}` : baseName ?? ''

  return new File([data], name, { type })
}

export const getAuthorizationGuideDocument = (
  finalizedDocument: any,
  surgicalOrder?: SurgicalOrderModel
): any => {
  if (finalizedDocument) return finalizedDocument

  const orderAuthorizationGuide = surgicalOrder?.documents?.find(
    (document) =>
      document?.type?.toLowerCase() ===
      PatientDocument.AUTHORIZATION_GUIDE.toLowerCase()
  )

  if (!orderAuthorizationGuide?.document_id) return undefined

  return {
    document_id: Number(orderAuthorizationGuide.document_id),
    type: orderAuthorizationGuide.type,
    name: orderAuthorizationGuide.name
  }
}
